export enum UnitTypeKey {
  OrganizationalUnits = 'ORGANIZATIONAL_UNIT',
  Process = 'PROCESS',
  Site = 'SITE',
  Building = 'BUILDING',
  Workplace = 'WORKPLACE',
  Facility = 'FACILITY'
}
